import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ReportCycleSearch} from '../../../../admin/models/report-cycle-search.interface';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-kf-configuration-admin-filter',
  templateUrl: './kf-configuration-admin-filter.component.html',
  styleUrls: ['./kf-configuration-admin-filter.component.scss']
})
export class KfConfigurationAdminFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    startYear: [''],
    schemaKind: [''],
    endYear: [''],
    entry: [''],
    unuKey: [''],
    kfCategory: [''],
    collectionStream: [''],
    startLaunched: [''],
    endLaunched: [''],
    open: []
  });

  get startYearControl(): FormControl {
    return this.searchForm.get('startYear') as FormControl;
  }
  get endYearControl(): FormControl {
    return this.searchForm.get('endYear') as FormControl;
  }

  get entryControl(): FormControl {
    return this.searchForm.get('entry') as FormControl;
  }

  get unuKeyControl(): FormControl {
    return this.searchForm.get('unuKey') as FormControl;
  }
  get kfCategoryControl(): FormControl {
    return this.searchForm.get('kfCategory') as FormControl;
  }
  get collectionStreamControl(): FormControl {
    return this.searchForm.get('collectionStream') as FormControl;
  }

  get openControl(): FormControl {
    return this.searchForm.get('open') as FormControl;
  }

  get schemaKindControl(): FormControl {
    return this.searchForm.get('schemaKind') as FormControl;
  }

  @Output()
  search: EventEmitter<ReportCycleSearch> = new EventEmitter<ReportCycleSearch>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.setFormValuesFromQueryParams();
  }

  handleSubmit(): void {
    const search: ReportCycleSearch = {
      startYear: this.startYearControl.value,
      endYear: this.endYearControl.value,
      entry: this.entryControl.value,
      unuKeyName: this.unuKeyControl.value,
      kfCategoryName: this.kfCategoryControl.value,
      collectionStreamName: this.collectionStreamControl.value,
      open: this.openControl.value,
      schemaKind: this.schemaKindControl.value
    };
    this.search.emit(search);
  }

  clean(): void {
    this.search.emit({});
  }

  private setFormValuesFromQueryParams(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        this.searchForm.get('startYear')?.setValue(params.startYear);
      }
      if (params.entry) {
        this.searchForm.get('entry')?.setValue(params.entry);
      }
      if (params.endYear) {
        this.searchForm.get('endYear')?.setValue(params.endYear);
      }
      if (params.unuKeyName) {
        this.searchForm.get('unuKey')?.setValue(params.unuKeyName);
      }
      if (params.kfCategoryName) {
        this.searchForm.get('kfCategory')?.setValue(params.kfCategoryName);
      }
      if (params.collectionStreamName) {
        this.searchForm.get('collectionStream')?.setValue(params.collectionStreamName);
      }
      if (params.launched) {
        this.searchForm.get('launched')?.setValue(params.launched);
      }
      if (params.startLaunched) {
        this.searchForm.get('startLaunched')?.setValue(params.startYear);
      }
      if (params.endLaunched) {
        this.searchForm.get('endLaunched')?.setValue(params.startLaunched);
      }

    });
  }

}
